module.exports = __webpack_public_path__ + "img/ic24Arrow.ffda2cfb.svg";